export interface Input {
  renderBody: Marko.Body;
  isMoreResultsBannerVisible?: boolean;
  "on-load-more": () => void;
  entryPageId?: string;
}

export default class extends Marko.Component<Input> {
  onLoadClickHandler() {
    this.emit("load-more");
  }
}
